export const VppUserLevel = "VppUserLevel";
export const VppZoneName = "VppZoneName";
export const VppGatesShow = "VppGatesShow";
export const VppAlarmsShow = "VppAlarmsShow";
export const VppCalendar = "VppCalendar";
export const VppGroupType = "VppGroupType";
export const UserGroup = "UserGroup";
export const DoorGroup = "DoorGroup";
export const VppCalRange = "VppCalRange";
